import { api } from "../../../api";
import { CustomsListResponse, RequestCustomsParams } from "../types";

export async function getLiteCustomsApi(
  params: RequestCustomsParams,
): Promise<CustomsListResponse> {
  const { data } = await api.get<CustomsListResponse>(`/api/customs-bill`, {
    params,
  });
  return data;
}

export async function exportCustomsBillApi(
  params?: Partial<RequestCustomsParams>,
): Promise<{ file: Blob; filename: string }> {
  const response = await api.get(`/api/customs-bill/export`, {
    params,
    responseType: "blob",
  });
  const disposition = response.headers["content-disposition"];
  let filename = "customs_bills.xlsx";
  if (disposition) {
    const match = disposition.match(/filename="?([^"]+)"?/);
    if (match && match[1]) {
      filename = decodeURIComponent(match[1]);
    }
  }
  return { file: response.data, filename };
}
